"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "groupBy", {
    enumerable: true,
    get: function() {
        return groupBy;
    }
});
const groupBy = (arr, key)=>arr.reduce((acc, item)=>(acc[item[key]] = [
            ...acc[item[key]] || [],
            item
        ], acc), {});
